import { formatApiErrorDetail } from "@/lib/api";

export const smsSegments = (text) => {
  const n = (text || "").length;
  if (!n) return 0;
  const unicode = [...text].some((ch) => ch.charCodeAt(0) > 127 && !"èéàòùì€".includes(ch));
  const per = unicode ? (n <= 70 ? 70 : 67) : (n <= 160 ? 160 : 153);
  return Math.ceil(n / per);
};

export const fmtEur = (v, d = 2) => (v == null ? "—" : `€ ${Number(v).toFixed(d).replace(".", ",")}`);

export const errMsg = (e) => formatApiErrorDetail(e?.response?.data?.detail ?? e?.message ?? e);

export const STATUS_IT = { draft: "bozza", queued: "in coda", scheduled: "programmata", sending: "in invio", sent: "inviata", completed: "conclusa", failed: "fallita", cancelled: "annullata" };
export const STATUS_CLS = {
  draft: "bg-slate-700/60 text-slate-300", queued: "bg-sky-500/15 text-sky-400", scheduled: "bg-sky-500/15 text-sky-400", sending: "bg-amber-500/15 text-amber-400",
  sent: "bg-[#10B981]/15 text-[#10B981]", completed: "bg-[#10B981]/15 text-[#10B981]", failed: "bg-[#EF4444]/15 text-[#EF4444]", cancelled: "bg-slate-700 text-slate-400",
};
